import './style.scss';
import { ChangePasswordBody } from '.';
import { useState } from 'react';
import { ChangePasswordProps } from './hooks';
import { ModalBase, ModalStyle } from 'views/mutual/modal';
import { Description, labelColor, labelSize } from 'views/mutual/description';

export const ChangePasswordModal = (props: ChangePasswordProps) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <ModalBase
      modalStyle={ModalStyle.Page}
      isOpen={isOpen}
      children={
        <div className="changePasswordModal">
          <Description
            labelColor={labelColor.gray}
            labelSize={labelSize.medium}
            label={
              <>
                <div>初期パスワードでのログイン時は</div>
                <div>パスワードの変更をしてください</div>
              </>
            }
          />
          <ChangePasswordBody
            onCompleted={() => {
              props.onCompleted?.();
              setIsOpen(false);
            }}
          />
        </div>
      }
      shouldCloseOnOverlayClick={false}
    />
  );
};
